import Products from "@/views/admin/product/Products";

export default {
  path: "products/list",
  name: "products",
  component: Products,
  props: true,
  meta: {
    requiresAuth: true
  }
};
